import type { Theme } from '@mui/material/styles'

const MuiFilledInput = (baseTheme: Theme) => ({
  defaultProps: {
    disableUnderline: true,
  },
  styleOverrides: {
    root: {
      borderRadius: baseTheme.shape.borderRadius,
      border: `1px solid transparent`,
      boxShadow: baseTheme.shadows[0],
      transition: 'all 300ms',

      '&:hover': {
        boxShadow: baseTheme.shadows[3],
      },
      '&.MuiInputBase-multiline': {
        paddingTop: 8,

        '& .MuiInputAdornment-root': {
          transform: `translateY(${baseTheme.spacing(-3.875)})`,
        },
      },
    },
    input: {
      height: baseTheme.spacing(1.875),
      paddingTop: baseTheme.spacing(1.375),
      paddingBottom: baseTheme.spacing(0.75),
      fontWeight: 500,
    },
  },
})

export default MuiFilledInput
